/** @format */

import DateOnly from '../../../../../utilities/format/date';
import {SHIPMENT_STATUS_COMPLETE} from 'frontier-constants';
import {OrdersDesignsList} from './designs_orders_list';
import NumberFormat from 'react-number-format';
import {IfElse, If} from 'frontier-utilities';
import {Table} from '@sttark/design-system';
import React from 'react';

// styles
import './order_shipping.scss';

export const OrderShipping = props => {
    const {cart} = props;

    const shipments = cart.shipments || [];
    const isCartShipped = cart.is_shipped;

    if (shipments.length === 0)
        return (
            <div className="order-view-shipping-87bx__empty">
                No shipments have been shipped yet come back later!
            </div>
        );

    return (
        <Table
            columns={[
                {
                    title: 'Shipment ID',
                    index: 'shipment_id',
                    key: 'shipment_id'
                },
                {
                    title: 'Ship Date',
                    index: 'ship_date',
                    key: 'ship_date'
                },
                {
                    title: 'Contains',
                    index: 'contains',
                    key: 'contains'
                },
                {
                    title: 'Total Qty',
                    index: 'total_qty',
                    key: 'total_qty'
                },
                {
                    title: '',
                    index: 'actions',
                    key: 'actions'
                }
            ]}
            rows={shipments.map(shipment => {
                const viewShippingSummaryPath = `/account/orders/preview-cart-summary/${shipment.cart_id}`;

                let totalShippedQty = 0;

                shipment.shipment_packages.forEach(pkg => {
                    pkg.designs_packages.forEach(design => {
                        totalShippedQty += Number(design.shipped_qty);
                    });
                });

                return {
                    shipment_id: (
                        <div className="order-view-shipping-87bx__id">
                            <p className="mb-1 mt-0 mx-0 p-0">#{shipment.id}</p>
                            <IfElse condition={!shipment.primary_tracking_code}>
                                <IfElse condition={shipment.is_shipping_local}>
                                    <p className="m-0 p-0">Local Pickup</p>
                                    <div className="order-view-shipping-87bx__shipping-method">
                                        <p className="m-0 p-0">Tracking Not Available Yet</p>
                                        <p className="m-0 p-0 color-structure-darker">
                                            {shipment.shipping_method_label}
                                        </p>
                                    </div>
                                </IfElse>
                                <a
                                    className="color-accent-primary d-flex align-items-center justify-content-start gap-2"
                                    href={shipment.tracking_url}
                                    rel="noopener noreferrer"
                                    target="_blank">
                                    <i className="fa fa-up-right-from-square" />
                                    <u>{shipment.primary_tracking_code}</u>
                                </a>
                            </IfElse>
                        </div>
                    ),
                    ship_date: (
                        <DateOnly>
                            {shipment.shipment_completed_time ?? shipment.quoted_ship_due_date}
                        </DateOnly>
                    ),
                    contains: (
                        <p className="m-0 p-0">
                            {shipment.designs_orders.length > 1
                                ? shipment.designs_orders.length + ' Designs'
                                : '1 Design'}
                        </p>
                    ),
                    total_qty: (
                        <NumberFormat
                            thousandSeparator={true}
                            value={totalShippedQty}
                            displayType="text"
                        />
                    ),
                    actions: (
                        <div className="order-view-shipping-87bx__actions">
                            <div>
                                <a
                                    className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                                    href={viewShippingSummaryPath}
                                    rel="noopener noreferrer"
                                    target="_blank">
                                    <i className="fa fa-truck" />
                                    <u>Shipment summary</u>
                                </a>
                                <If
                                    condition={
                                        shipment.primary_tracking_code ||
                                        (shipment.is_shipping_local &&
                                            shipment.status_id === SHIPMENT_STATUS_COMPLETE)
                                    }>
                                    <a
                                        className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                                        href={`/account/shipments/packing-list-authenticated/${shipment.id}`}
                                        target="_blank">
                                        <i className="fa fa-cube" />
                                        <u>View Packing List</u>
                                    </a>
                                </If>
                            </div>
                        </div>
                    ),
                    renderData: shipment,
                    key: shipment.id
                };
            })}
            className="order-view-shipping-87bx"
            isExpandable={isCartShipped}>
            <OrdersDesignsList />
        </Table>
    );
};
